import { makeAutoObservable } from 'mobx';

export class IntegrationsStore {
  private pending: Set<string> = new Set();

  constructor() {
    makeAutoObservable(this);
  }

  isPending(toolkitName: string): boolean {
    return this.pending.has(toolkitName);
  }

  markPending(toolkitName: string): void {
    this.pending.add(toolkitName);
  }

  unmarkPending(toolkitName: string): void {
    this.pending.delete(toolkitName);
  }
}

export const integrationsStore = new IntegrationsStore();
